import { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate, Link, useLocation } from 'react-router-dom';
import { UploadPage } from './pages/UploadPage';
import { InventoryPage } from './pages/InventoryPage';
import { api } from './services/api';
import './App.css';

function App() {
  const [tenantId, setTenantId] = useState<string | null>(() => {
    return localStorage.getItem('tenantId');
  });

  const handleSetTenant = (id: string) => {
    localStorage.setItem('tenantId', id);
    api.setTenantId(id);
    setTenantId(id);
  };

  const handleClearTenant = () => {
    localStorage.removeItem('tenantId');
    api.setTenantId(null);
    setTenantId(null);
  };

  // Set tenant ID on initial load
  useEffect(() => {
    if (tenantId) {
      api.setTenantId(tenantId);
    }
  }, [tenantId]);

  // If no tenant ID, show tenant selection
  if (!tenantId) {
    return <TenantSelector onSetTenant={handleSetTenant} />;
  }

  return (
    <BrowserRouter>
      <div className="app">
        <Navigation tenantId={tenantId} onClearTenant={handleClearTenant} />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<UploadPage />} />
            <Route path="/inventory" element={<InventoryPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
      </div>
    </BrowserRouter>
  );
}

function TenantSelector({ onSetTenant }: { onSetTenant: (id: string) => void }) {
  const [inputValue, setInputValue] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (inputValue.trim()) {
      onSetTenant(inputValue.trim());
    }
  };

  return (
    <div className="tenant-selector">
      <div className="tenant-container">
        <h1>Vision Inventory</h1>
        <p className="subtitle">Restaurant Inventory Management</p>

        <form onSubmit={handleSubmit} className="tenant-form">
          <h2>Enter Your Tenant ID</h2>
          <p className="description">
            Enter your restaurant tenant ID to access the inventory system.
          </p>

          <div className="form-group">
            <label htmlFor="tenantId">Tenant ID</label>
            <input
              id="tenantId"
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              required
              placeholder="e.g., restaurant-123"
              autoFocus
            />
          </div>

          <button type="submit" className="submit-btn">
            Continue
          </button>
        </form>
      </div>
    </div>
  );
}

function Navigation({ tenantId, onClearTenant }: { tenantId: string; onClearTenant: () => void }) {
  const location = useLocation();

  return (
    <nav className="navigation">
      <div className="nav-brand">
        <span className="logo">📦</span>
        <span className="brand-name">Vision Inventory</span>
      </div>
      <div className="nav-links">
        <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
          Upload
        </Link>
        <Link to="/inventory" className={location.pathname === '/inventory' ? 'active' : ''}>
          Inventory
        </Link>
      </div>
      <div className="nav-user">
        <span className="tenant-badge">Tenant: {tenantId}</span>
        <button onClick={onClearTenant} className="logout-btn">
          Change Tenant
        </button>
      </div>
    </nav>
  );
}

export default App;
